// yct_thrift — gentle scroll-reveal for sections, headings, images and grid items.
// Adds .yct-reveal (start hidden) + .yct-reveal--in (animate in) as elements enter view.
// Fully no-op if the user prefers reduced motion, and degrades to fully-visible if JS fails.

(() => {
  if (window.__yctReveal) return;
  window.__yctReveal = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const SECTION = '.section-wrapper:not(.yct-hero)';
  const ITEMS = [
    '.product-grid__item',
    '.yct-catgrid__card',
    '.yct-collgrid__item',
    '.yct-collstrip__item',
    '.yct-review',
    '.yct-trust__badge',
    '.value-banner__feature',
    '.yct-hero__inner > *',
  ].join(',');

  const EXCLUDE = '#header-group, header, footer, .header, .footer, .menu-drawer, #cart-drawer, dialog, .theme-drawer__dialog';
  const GRID = '.product-grid, .yct-catgrid__grid, .yct-collgrid__grid, .yct-reviews__track, .value-banner__features';

  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        e.target.classList.add('yct-reveal--in');
        io.unobserve(e.target);
      }
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.04 }
  );

  const seen = new WeakSet();

  const register = (el, staggerIndex) => {
    if (seen.has(el) || el.closest(EXCLUDE)) return;
    seen.add(el);
    el.classList.add('yct-reveal');
    if (staggerIndex != null) {
      el.style.setProperty('--yct-reveal-delay', `${Math.min(staggerIndex, 7) * 55}ms`);
    }
    io.observe(el);
  };

  const scan = (root = document) => {
    document.body.classList.add('yct-reveal-ready');

    root.querySelectorAll(SECTION).forEach((sec) => {
      // sections that hold a grid only fade (no lift) so the staggered items carry the motion
      if (sec.querySelector(GRID)) sec.classList.add('yct-reveal--soft');
      register(sec);
    });

    // group staggered items by their nearest container so each grid counts from 0
    const items = [...root.querySelectorAll(ITEMS)];
    const counts = new Map();
    for (const el of items) {
      const key = el.parentElement || document.body;
      const i = counts.get(key) || 0;
      counts.set(key, i + 1);
      register(el, i);
    }
  };

  const init = () => scan();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // failsafe: never leave anything hidden if something goes wrong
  setTimeout(() => {
    document.querySelectorAll('.yct-reveal:not(.yct-reveal--in)').forEach((el) => el.classList.add('yct-reveal--in'));
  }, 2600);

  // re-scan when the theme editor / Section Rendering API swaps a section in
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();
